


// import react and some other libs
import {
  React, ReactDOM, Component, Moment

} from 'app/react/Boot.jsx';


// importing core functionality
import {
  mapParTypeName, mapParTypeNameToTag, mapUnitNameToTag, mapUnitName
} from 'app/react/core/CoreUtils.jsx';

function decimals(value, decimals) {
  return Number(Math.round(value+'e'+decimals)+'e-'+decimals);
}

// this will add support for css element queries
// we need only resize sensor to effectivelly get the element size
import {ResizeSensor} from 'css-element-queries';

class SimpleTable extends Component {

  constructor(props) {
    super(props)

    this.lastResizeEvent = null;

    this.state = {
      legendSize: 'full'
    }
  }

  componentWillReceiveProps(props) {
    // react on change of properties

    if (this.lastResizeEvent)
      this.onResize(this.lastResizeEvent)
  }

  componentDidMount() {

    console.log('mounting component ')
    this.startSizeDetector();

    this.sizeDetector.lastSize.width = this.container.clientWidth;
    this.sizeDetector.lastSize.height = this.container.clientHeight - 18;

    this.onResize({ size: this.sizeDetector.lastSize} );
  }

  applyReactiveDescription(size) {
    var d = this.props.reactiveDescription;

    for (var p in d) {
      for (var v in d[p]) {
        if (size[p] >= parseFloat(v)) {
          for (var r in d[p][v]) {

            console.log('applying reactive description to table')
            if (r == "legendSize") {
              this.state.legendSize = d[p][v][r];
            }
          }
        }
      }
    }
  }


  onResize(event) {
    this.lastResizeEvent = event;

    console.log('resizing container')

    // this.state.width = this.refs.svg.clientWidth;
    // this.state.height = this.refs.svg.clientHeight;

    if (this.props.reactiveDescription) {
      // we are trying to change chart parameters based on container size
      this.applyReactiveDescription(event.size);
    }

    this.forceUpdate();
    //this.props.onResize(event.size);
  }


  onTableContainerScroll(event) {
    var dom = ReactDOM.findDOMNode(this.refs["tableHeader"]);
    var scrollTop = event.target.scrollTop;

    window.requestAnimationFrame(function () {
      if (dom)
        dom.style.top = scrollTop;
    })
  }

  formatNumericValue(code, value) {
    var val = value;

    switch (code) {
      case "t": {
        val = Moment(new Date(value * 1000)).format(this.props.dateFormat)
        break;
      }
      default: {
        if (val != "") {
          //val = Math.floor(value * 10) / 10;
          if (!this.props.decimals) {
            val = Math.round(value);
          } else {
            val = decimals(value, this.props.decimals)
          }
        } else {
          val = "-";
        }
        break;
      }
    }
    return val;
  }


  startSizeDetector() {

    this.sizeDetector = {
      lastSize: { width: 0, height: 0 }, ts: 0
    }

    console.log('setting resize sensor on container: ', this.container)

    this.resizeSensor = new ResizeSensor(this.container, () => {
      this.sizeDetector.lastSize.width = this.container.clientWidth;
      this.sizeDetector.lastSize.height = this.container.clientHeight - 18;

      //console.log('rozmiary komponentu: ', this.tableContainer.offsetHeight, this.tableContainer.offsetWidth)
      this.onResize({
        target: this.container,
        size: this.sizeDetector.lastSize
      })
    })
  }


  render () {

    //generateTable (desc, tableWidth, tableHeight) {
    var dp = this.props.dataProvider;
    // desc.headers
    // desc.colSpans
    // HeaderRenderer
    // rowRenderer
    //
    var tableWidth = this.props.tableWidth;
    var tableHeight = this.props.tableHeight;
    var desc = this.props.desc;

    console.log('generating table with desc: ', desc)

    var legendSize = (this.props.codes.length > 6 ? "short" : this.state.legendSize);
    var headerRenderer = desc && desc.headerRenderer;

    if (!desc || !desc.headerRenderer) {
      headerRenderer = function (headerData, j) {
        var {code, colStyle, colspan} = headerData;
        return (code == "Data" ?
        <th style={{width: "150px"}} key={j}><span>{name}</span></th> :
          <th colSpan={colspan} style={colStyle} key={j}><span>{code}</span><br/></th>
        );
      }
    }

    var secondHeaderRenderer = desc && desc.secondHeaderRenderer;

    if (!desc || !desc.secondHeaderRenderer) {
      secondHeaderRenderer = function (rowData, j) {
        var {code, name, unit, type} = rowData;

        return (code == "Data" ?
        <th style={{width: "150px"}} key={j}><span>{(legendSize == "full"? name : type)}</span></th> :
          <th style={{width: "50%", position: 'relative'}} key={j}><span dangerouslySetInnerHTML={{__html: (legendSize == "full"? name : type)}}></span>
          <br/>{legendSize == "full" ? <span style={{marginLeft: 0, marginTop: 10, display: 'block'}}>[{unit}]</span> : null} </th>);
          }
        }

        var containerStyle = {
          width: tableWidth, height: tableHeight,
          overflowY: 'scroll',overflowX: 'hidden', position: 'relative', display: 'block'
        }

        return (
          <div ref={(r) => this.container = r} onScroll={this.onTableContainerScroll.bind(this)} style={containerStyle}>
            {this.props.values &&
              <table className="bielany-table table-hover table-bordered">
                <thead>
                  {!desc.onerowheader &&
                    <tr>
                      {desc.headers.map((headerData, j) => {
                        return headerRenderer(headerData, j);
                      })}
                    </tr>
                  }
                  <tr>
                    {["Data"].concat(this.props.codes).map((code, j) => {
                      var meas = dp.getStore('measurement_by_code').getRecordById(code);
                      var name = code;
                      var type = name;
                      var compound_type;
                      var unit;


                      //  var station = /051.*/.test(code) ? "Ludowa" : "Kraszewskiego";

                      if (meas) {
                        compound_type = dp.getStore('chemical_compound').getRecordById(meas.compound_type);


                        type = mapParTypeName(compound_type.compound_type.toUpperCase());
                        name = compound_type.name
                        .replace(/PM10/g, mapParTypeName('PM10'))
                        .replace(/PM1/g, mapParTypeName('PM1'))
                        .replace(/PM25/g, mapParTypeName('PM25'))
                        .replace(/PM2\.5/g, mapParTypeName('PM25'))
                        ;
                        //unit = mapUnitNameToTag(compound_type.agg_unit);
                        unit = mapUnitNameToTag(meas.unit_id);

                        console.log('measurement: ', meas, meas.compound_type, compound_type, compound_type.compound_type.toUpperCase(), name)

                      }
                      console.log('checking code: ', code, name, type, meas, compound_type, unit)
                      return secondHeaderRenderer({code, name, unit, type}, j)
                    })}
                  </tr>
                </thead>

                <tbody>
                  {this.props.values.map((r, i) => {
                    return <tr key={i}>
                      {
                        ["t"].concat(this.props.codes).map((code, j) => {
                          return <td key={j}>{this.formatNumericValue(code, r[code])}</td>;
                          })
                        }
                      </tr>
                    })}
                  </tbody>
                </table>
              }
              {this.props.values &&
                <table ref="tableHeader" className="bielany-table table-hover table-bordered" style={{position: 'absolute'}}>
                  <thead>
                    {!desc.onerowheader &&
                      <tr>
                        {desc.headers.map((headerData, j) => {
                          return headerRenderer(headerData, j);
                        })}
                      </tr>
                    }
                    <tr>
                      {["Data"].concat(this.props.codes).map((code, j) => {
                        var meas = dp.getStore('measurement_by_code').getRecordById(code);
                        var name = code;
                        var type = name;
                        var compound_type;
                        var unit;
                        //  var station = /051.*/.test(code) ? "Ludowa" : "Kraszewskiego";

                        if (meas) {
                          compound_type = dp.getStore('chemical_compound').getRecordById(meas.compound_type);
                          type = mapParTypeName(compound_type.compound_type.toUpperCase());
                          name = compound_type.name
                          .replace(/PM10/g, mapParTypeName('PM10'))
                          .replace(/PM1/g, mapParTypeName('PM1'))
                          .replace(/PM25/g, mapParTypeName('PM25'))
                          .replace(/PM2\.5/g, mapParTypeName('PM25'))
                        //  unit = mapUnitNameToTag(compound_type.agg_unit);
                          unit = mapUnitNameToTag(meas.unit_id);
                        }

                        return secondHeaderRenderer({code, name, unit, type}, j)
                      })}
                    </tr>
                  </thead>
                  <tbody>
                  </tbody>
                </table>
              }
            </div>
          );
        }

      }

      export default SimpleTable;



// WEBPACK FOOTER //
// ./app/react/table/SimpleTable.jsx